import moment from "moment";

export default {
    namespaced: true,
    state: () => ({
        user: null,
        isLogin: false,
        isSocketConnect: false,
        
        currentRoom: null,
        isOpenLiveStream: false,
    }),
    getters: {
        tokenHeader(state){
            return {
                headers: {
                    authorization: `Bearer ${ state.user?.token }`
                }
            }
        }
    },
    actions: {
        SOCKET_error({ state, commit }, err){
            console.log("SOCKET_error -> ", err);
            if(err == "Authentication Error"){
                localStorage.removeItem(process.env.cookie_name);
                if(window.location.pathname != "/") window.location.href = "/";
            }else if(err == "Unauthorized Action"){
                this.$swal({
                    title: err,
                    icon: "error"
                })
            }
        },
        SOCKET_connect({ state, commit }){
            console.log("--- socket connected ---");
            if(state.isLogin){
                this._vm.$socket.emit("setIdentity");
            }
            commit("setIsSocketConnect", true);
        },
        SOCKET_disconnect({ commit }){
            console.log("--- socket disconnected ---");
            commit("setIsSocketConnect", false);
        },
        SOCKET_onGlobalDeactiveUser({ state, dispatch }, res){
            console.log("SOCKET_onGlobalDeactiveUser ->", res);
            if(state.user){
                dispatch("onLogoutUser");
            }
        },
        SOCKET_onDeactiveUser({ state, dispatch }, res){
            console.log("SOCKET_onDeactiveUser ->", res);
            if(res.id == state.user.id){
                dispatch("onLogoutUser");
            }
        },
        onSetGA({ state }, res){
            this.$gtm.push({ event: "click_event", action: res, user: state.user.email});
            this.$ga.event({ eventCategory: "click_event", eventAction: res, user: state.user.email });
        },
        onTriggerAnalytics({ state }, res){
            // console.log('onTriggerAnalytics ->', res.event, ':', res.action || res.route);

            // if(process.env.NODE_ENV == "production"){
            // if(process.env.NODE_ENV == "production" && !process.env.is_stg){
                var user = (state.user?.email || res.email)|| "guest";
                // var user = (state.user?.id || res.id)|| "guest";
                // this._vm.onTriggerGA({ user, value: res.action });

                // var data = {
                //     projectid: process.env.ta_id,
                //     userhid: user,
                //     route: res.route,
                // };
                
                // if(res.event == 'click_event'){
                    const timestamp = moment().format("YYYYMMDDHHmm");
                    this.$gtm.push({ event: res.event, action: res.action, user, user_id: user, timestamp });
                    this.$ga.event({ eventCategory: res.event, eventAction: res.action, user_id: user, timestamp });
                //     var url = `${ process.env.analytic_url }/api/click_event`;
                //     data.event = res.event;
                //     data.action = res.action;
                // }else{
                //     var url = `${ process.env.analytic_url }/api/send_data`;
                //     data.triggerPoint = res.event;
                // }

                // this.$axios.$post(url, data).then((res) => {
                //     // console.log('analyticCallback', res);
                // }).catch((err) => {
                //     console.error('analyticError', err);
                // });
            // }
        },
        onLogoutUser(){
            localStorage.removeItem(process.env.cookieName);
            localStorage.removeItem(`${ process.env.cookieName }_opening_video`);
            window.location.href = "/";
        }
    },
    mutations: {
        setUser(state, user){
            state.user = user;
            state.isLogin = user ? true : false;
            console.log("--- auth setted ---");
        },
        updateUser(state, item){
            state.user = { ...state.user, ...item };
            localStorage.setItem(process.env.cookieName, JSON.stringify(state.user));
            // console.log(state.user)
        },
        setIsSocketConnect(state, item){
            state.isSocketConnect = item;
        },
        setCurrentRoom(state, item){
            state.currentRoom = item;
        },
        setIsOpenLiveStream(state, item){
            state.isOpenLiveStream = item;
        },
    }
}